import type { Offset } from '@octopus-do/octopus-project-core'

export const COMMENTABLE_TARGET = 'data-commentable-target'

// the comment-mode layer over the canvas; the drag handler pans it like the canvas
export const NEW_THREAD_LAYER_ID = 'newThreadLayer'

// the offset points at the top of the bubble, the click at its pointed
// bottom-left corner, so the shift is the bubble height: 24px avatar
// plus its 1px border and the 3px padding of the stack around it
export const THREAD_FORM_SHIFT: Offset = { x: 0, y: 32 }

// the open card beside its bubble: its width (ThreadComments) and the gap
// between them (ThreadItem), read to tell whether it fits on the right
export const THREAD_CARD_WIDTH = 280
export const THREAD_CARD_GAP = 12
